import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

interface IProps {
  customerId: string;
  companyId: string;
}

export const useDisconnectGusto = ({ customerId, companyId }: IProps, onSuccess?: () => void, onError?: (error: any) => void) => useMutation(
  'disconnectGusto',
  async () => {
    const { data } = await httpService.delete(`${BASE_URL}/api/v1/user/${customerId}/payroll/link/${companyId}`);
    return data;
  },
  {
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
    onError: (error: any) => {
      if (onError) onError(error);
    },
  },
);
